/** Route guards. */
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth, userIsAdmin, userIsStaff } from "./AuthContext";
import { LoadingState } from "../../components/ui";

export function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) return <LoadingState label="Loading session…" />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return children || <Outlet />;
}

export function RequireAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) return <LoadingState label="Checking access…" />;
  if (!user) return <Navigate to="/login?next=/admin" replace />;
  if (!userIsAdmin(user) && !userIsStaff(user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children || <Outlet />;
}

export function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <LoadingState label="Checking access…" />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "super_admin") return children || <Outlet />;
  if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children || <Outlet />;
}
